import React, { useState, useEffect } from "react";

const UserModal = ({ user, onClose, onUpdateStatus }) => {

  console.log("User Data:", user);

  
  const [status, setStatus] = useState(user.status || "pending");

  
  useEffect(() => {
    setStatus(user.status || "pending");
  }, [user]);

  const handleSubmit = () => {
    if (onUpdateStatus) {
      onUpdateStatus(user.id, status);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
    >
      <div className="bg-white rounded-xl shadow-lg w-full max-w-lg p-6 overflow-y-auto max-h-[90vh]">
        {/* Header */}
        <div className="flex justify-between items-center border-b pb-3 mb-4">
          <h2 className="text-xl font-semibold text-gray-800">User Details</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 text-lg"
          >
            ✕
          </button>
        </div>

        {/* Profile Section */}
        <div className="flex flex-col items-center">
          <img
            src={user.profileImageUrl || "N/A"}
            alt={user.userName || "N/A"}
            className="w-28 h-28 rounded-full object-cover mb-3"
          />
          <h3 className="text-2xl font-bold text-gray-900">
            {user.userName || "Unknown User"}
          </h3>
          <p className="text-gray-600">{user.userEmail || "N/A"}</p>
        </div>

        {/* Info Grid */}
        <div className="mt-6 grid grid-cols-2 gap-4 text-sm">
          <div>
            <p className="font-semibold text-gray-700">Email:</p>
            <p className="text-gray-600">{user.userEmail || "N/A"}</p>
          </div>
          <div>
            <p className="font-semibold text-gray-700">Phone:</p>
            <p className="text-gray-600">{user.mobile || "N/A"}</p>
          </div>

          <div>
            <p className="font-semibold text-gray-700">Method:</p>
            <p className="text-gray-600">{user.method || "N/A"}</p>
          </div>
          <div>
            {user.method === "Bank Account" ? (
              <div className="text-gray-600">
                <p className="font-semibold text-gray-700">Account No:</p>
                <p>{user.bankAccount || "N/A"}</p>
              </div>
            ) : (
              <div className="text-gray-600">
                <p className="font-semibold text-gray-700">UPI ID:</p>
                <p>{user.upiId || "N/A"}</p>
              </div>
            )}
          </div>

          {user.method === "Bank Account" ? (
            <div className="text-gray-600">
              <p className="font-semibold text-gray-700">IFSC:</p>
              <p>{user.ifsc || "N/A"}</p>
            </div>
          ) : null}

          <div>
            <p className="font-semibold text-gray-700">Amount (₹):</p>
            <p className="text-gray-600">{user.amountRupees || "0"}</p>
          </div>
          <div>
            <p className="font-semibold text-gray-700">Fee (₹):</p>
            <p className="text-gray-600">{user.feeRupees || "0"}</p>
          </div>

          <div>
            <p className="font-semibold text-gray-700">Receive (₹):</p>
            <p className="text-gray-600">{user.receiveRupees || "0"}</p>
          </div>
          <div>
            <p className="font-semibold text-gray-700">Diamonds:</p>
            <p className="text-gray-600">{user.diamonds || "0"}</p>
          </div>

          {/* Editable Status */}
          <div>
            <p className="font-semibold text-gray-700">Status:</p>
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              className="border rounded-md px-2 py-1 mt-1 w-full"
            >
              <option value="pending">Pending</option>
              <option value="successful">Successful</option>
              <option value="rejected">Rejected</option>
            </select>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-6 flex justify-between">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
          >
            Close
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserModal;
